import {ProcesosSeguros} from './ProcesosSeguros';
export default ProcesosSeguros;
